/* ============================================================
   EVOLVED MARKETPLACE — main.js
   ============================================================ */

/* ---------- Add to cart (AJAX) ---------- */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-product-id]');
  if (!btn || btn.disabled) return;
  const id = btn.dataset.productId;
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });
    if (!res.ok) throw new Error();
    const item = await res.json();
    showToast('Added ' + item.product_title + ' to cart');
    // Update cart badge count
    const countRes = await fetch('/cart.js');
    const cart = await countRes.json();
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    // If badge doesn't exist, create it
    document.querySelectorAll('.cart-link').forEach(link => {
      let badge = link.querySelector('.cart-badge');
      if (!badge && cart.item_count > 0) {
        badge = document.createElement('span');
        badge.className = 'cart-badge';
        link.appendChild(badge);
      }
      if (badge) badge.textContent = cart.item_count;
    });
  } catch {
    showToast('Could not add to cart — try again.');
  } finally {
    btn.disabled = false;
  }
});

/* ---------- Toast ---------- */
function showToast(msg) {
  let wrap = document.querySelector('.toast-wrap');
  if (!wrap) { wrap = document.createElement('div'); wrap.className = 'toast-wrap'; document.body.appendChild(wrap); }
  const t = document.createElement('div'); t.className = 'toast';
  t.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg><span>' + msg + '</span>';
  wrap.appendChild(t);
  requestAnimationFrame(() => t.classList.add('show'));
  setTimeout(() => { t.classList.remove('show'); setTimeout(() => t.remove(), 300); }, 2500);
}

/* ---------- Newsletter form ---------- */
document.querySelectorAll('[data-notify]').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const msg = form.dataset.notify;
    showToast(msg);
    form.reset();
  });
});

/* ---------- Product gallery thumbnails ---------- */
document.querySelectorAll('.pdp-thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const src = thumb.querySelector('img')?.src;
    const main = document.querySelector('.pdp-main-img img');
    if (main && src) main.src = src;
    document.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

/* ---------- Cart quantity ---------- */
document.querySelectorAll('.cart-qty button').forEach(btn => {
  btn.addEventListener('click', async () => {
    const row = btn.closest('.cart-row');
    const key = row?.dataset.lineKey;
    const delta = btn.dataset.dir === 'up' ? 1 : -1;
    if (!key) return;
    const qtyEl = row.querySelector('.cart-qty-val');
    const newQty = Math.max(0, parseInt(qtyEl?.textContent || 1) + delta);
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    window.location.reload();
  });
});

/* ---------- Special offer widget ---------- */
(function() {
  const tab     = document.getElementById('emOfferTab');
  const overlay = document.getElementById('emOfferOverlay');
  const card    = document.getElementById('emOfferCard');
  const closeBtn = document.getElementById('emOfferClose');
  const form    = document.getElementById('emOfferForm');
  const emailEl = document.getElementById('emOfferEmail');
  const err     = document.getElementById('emOfferErr');
  if (!tab) return;

  /* --- One-time offer config --- */
  const OFFER_CODE  = 'Welcome10';            // discount code shown to the visitor
  const STORAGE_KEY = 'em_offer_claimed_v1';  // bump the _v1 suffix to reset everyone

  // localStorage can throw in private mode / when disabled, so wrap it.
  function isClaimed() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; }
    catch (e) { return false; }
  }
  function markClaimed() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  // Slide the tab in after a short delay once the page loads
  setTimeout(() => { tab.classList.add('is-visible'); }, 2500);

  function openModal() { overlay.classList.add('open'); setTimeout(() => { if (emailEl) emailEl.focus(); }, 80); }
  function closeModal(){ overlay.classList.remove('open'); }
  tab.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

  // Inject the result block (code + message). Removes any previous one first
  // so refreshing / re-opening never stacks duplicates.
  function renderResult(titleText, descHtml, fineHtml) {
    card.classList.add('em-success');
    const title = document.getElementById('emOfferTitle');
    if (title) title.textContent = titleText;
    const prev = card.querySelector('.em-offer-result');
    if (prev) prev.remove();
    const d = document.createElement('div');
    d.className = 'em-offer-result';
    d.innerHTML =
      '<p class="em-desc" style="display:block">' + descHtml + '</p>' +
      '<span class="em-code">' + OFFER_CODE + '</span>' +
      '<p class="em-fine">' + fineHtml + '</p>';
    if (form) { form.parentNode.insertBefore(d, form.nextSibling); }
    else { card.appendChild(d); }
  }

  // First-time reveal (only happens once per browser)
  function renderReveal() {
    renderResult(
      'You\u2019re in! \uD83C\uDF89',
      'Here\u2019s your code for 10% off:',
      'Apply at checkout. Happy collecting!'
    );
  }

  // "Already claimed" state — shown on refresh / re-open after the first claim
  function renderClaimed() {
    card.classList.add('em-claimed');
    renderResult(
      'Already claimed',
      'You\u2019ve already claimed this offer on this device. Your code is:',
      'This one-time code can only be claimed once. Apply it at checkout if you haven\u2019t already.'
    );
  }

  // On page load: if this browser already claimed, show the claimed state up front.
  if (isClaimed()) renderClaimed();

  form.addEventListener('submit', e => {
    e.preventDefault();
    // Guard: if somehow already claimed, never re-issue.
    if (isClaimed()) { renderClaimed(); return; }
    const v = emailEl.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { err.textContent = 'Please enter a valid email.'; emailEl.focus(); return; }
    err.textContent = '';
    markClaimed();   // lock it in *before* revealing
    renderReveal();
  });
})();

/* ============================================================
   ROTATING SEARCH PLACEHOLDER
   Cycles suggested terms in the empty search box (before focus).
   Adapted from the reference design. Stops on focus / when typed in,
   and respects prefers-reduced-motion.
   ============================================================ */
(function () {
  const field = document.querySelector('.mega-search .ms-field');
  if (!field) return;
  const ph    = field.querySelector('.ms-ph');
  const input = field.querySelector('input');
  if (!ph || !input) return;

  const terms = [
    '"sealed case"',
    '"artboard"',
    '"holo slab"',
    '"mystery box"',
    '"acrylic magnet"',
    '"polaroid"',
    '"binder"'
  ];
  let i = 0, timer = null;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function render() { ph.textContent = 'Try ' + terms[i]; }
  render();

  function cycle() {
    ph.classList.add('is-fading');
    setTimeout(() => {
      i = (i + 1) % terms.length;
      render();
      ph.classList.remove('is-fading');
    }, 450);
  }
  function start() { if (reduce || timer) return; timer = setInterval(cycle, 3200); }
  function stop()  { if (timer) { clearInterval(timer); timer = null; } }

  function sync() {
    if (document.activeElement === input || input.value.trim() !== '') {
      field.classList.add('ms-active');
      stop();
    } else {
      field.classList.remove('ms-active');
      start();
    }
  }

  input.addEventListener('focus', sync);
  input.addEventListener('blur', sync);
  input.addEventListener('input', sync);
  // Pause when the tab is hidden (avoids wasted timers)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop(); else sync();
  });
  sync();
})();

/* ============================================================
   PREDICTIVE SEARCH
   Uses Shopify Predictive Search API: /search/suggest.json
   ============================================================ */
(function () {
  const input     = document.getElementById('searchInput');
  const dropdown  = document.getElementById('searchDropdown');
  const searchWrap = document.getElementById('searchWrap');
  if (!input || !dropdown) return;

  let debounceTimer = null;
  let currentQuery  = '';
  let activeIndex   = -1;
  let results       = [];

  // ---- helpers ----
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function highlight(text, query) {
    if (!query) return escHtml(text);
    const re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return escHtml(text).replace(re, '<mark>$1</mark>');
  }

  function escHtml(s) {
    return String(s).replace(/[<>&"']/g, c =>
      ({ '<':'&lt;', '>':'&gt;', '&':'&amp;', '"':'&quot;', "'":'&#39;' }[c]));
  }

  // ---- category suggestions (dynamic) ----
  function matchCategories(query) {
    const q = (query || '').trim().toLowerCase();
    if (!q) return CATEGORIES.slice();
    return CATEGORIES.filter(c =>
      c.label.toLowerCase().includes(q) || c.handle.replace(/-/g, ' ').includes(q)
    );
  }

  function categoryRow(c, query) {
    const img = CAT_IMG[c.handle]
      ? `<img class="search-result-img" src="${CAT_IMG[c.handle]}" alt="" width="46" height="46" loading="lazy">`
      : `<div class="search-result-img-placeholder"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg></div>`;
    return `<a class="search-result" href="/collections/${c.handle}">
      ${img}
      <div class="search-result-info">
        <div class="search-result-title">${highlight(c.label, query)}</div>
        <div class="search-result-type">Category</div>
      </div>
    </a>`;
  }

  // ---- open / close ----
  function openDropdown() {
    dropdown.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown() {
    dropdown.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    activeIndex = -1;
  }

  // ---- render ----
  function renderResults(data, query) {
    const products  = (data.resources && data.resources.results && data.resources.results.products)  || [];
    const queries   = (data.resources && data.resources.results && data.resources.results.queries)   || [];
    results = products;

    const catMatches = matchCategories(query);

    if (!products.length && !queries.length && !catMatches.length) {
      dropdown.innerHTML = `<p class="search-empty">No results for "<strong>${escHtml(query)}</strong>" — try different keywords.</p>
        <a class="search-query-link" href="/search?type=product&q=${encodeURIComponent(query)}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          See all results for "<strong>${escHtml(query)}</strong>"
        </a>`;
      openDropdown();
      return;
    }

    let html = '';

    // Category suggestions (dynamically filtered as the user types)
    if (catMatches.length) {
      html += `<div class="search-section-label">Categories</div>`;
      html += catMatches.map(c => categoryRow(c, query)).join('');
    }

    // Query suggestions
    if (queries.length) {
      html += `<div class="search-section-label">Suggestions</div>`;
      queries.slice(0, 3).forEach(q => {
        html += `<a class="search-result" href="/search?type=product&q=${encodeURIComponent(q.text)}">
          <div class="search-result-img-placeholder">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          </div>
          <div class="search-result-info">
            <div class="search-result-title">${highlight(q.text, query)}</div>
          </div>
        </a>`;
      });
    }

    // Product results
    if (products.length) {
      html += `<div class="search-section-label">Products</div>`;
      products.slice(0, 6).forEach((p, i) => {
        const img = p.featured_image
          ? `<img class="search-result-img" src="${escHtml(p.featured_image.url)}" alt="${escHtml(p.featured_image.alt || p.title)}" width="46" height="46" loading="lazy">`
          : `<div class="search-result-img-placeholder"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg></div>`;

        const price = p.price ? money(p.price) : '';
        const compareAt = p.compare_at_price && p.compare_at_price > p.price
          ? `<span style="text-decoration:line-through;color:var(--ink-soft);margin-left:.4rem;font-weight:400">${money(p.compare_at_price)}</span>` : '';

        html += `<a class="search-result" href="${escHtml(p.url)}" role="option" id="sr-${i}" aria-selected="false">
          ${img}
          <div class="search-result-info">
            <div class="search-result-title">${highlight(p.title, query)}</div>
            ${p.product_type ? `<div class="search-result-type">${escHtml(p.product_type)}</div>` : ''}
            ${price ? `<div class="search-result-price">${price}${compareAt}</div>` : ''}
          </div>
        </a>`;
      });
    }

    // "See all" footer
    html += `<a class="search-query-link" href="/search?type=product&q=${encodeURIComponent(query)}">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
      See all results for "<strong>${escHtml(query)}</strong>"
    </a>`;

    dropdown.innerHTML = html;
    openDropdown();
    activeIndex = -1;
  }

  function showLoading() {
    dropdown.innerHTML = `<div class="search-loading"><span class="search-spinner"></span></div>`;
    openDropdown();
  }

  // ---- fetch ----
  async function fetchSuggestions(query) {
    currentQuery = query;
    // Note: categories are already shown instantly by the input handler,
    // so we don't blank the dropdown with a spinner here.
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { headers: { 'Content-Type': 'application/json' } });
      if (!res.ok) throw new Error();
      const data = await res.json();
      if (query === currentQuery) renderResults(data, query);
    } catch {
      // Network/API error: fall back to showing matching categories
      if (query === currentQuery) showCategories(query);
    }
  }

  // ---- keyboard navigation ----
  function updateActive(newIndex) {
    const items = dropdown.querySelectorAll('.search-result[role="option"]');
    if (!items.length) return;
    items.forEach((el, i) => {
      el.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
      if (i === newIndex) el.classList.add('active');
      else el.classList.remove('active');
    });
    activeIndex = newIndex;
  }

  input.addEventListener('keydown', e => {
    const items = dropdown.querySelectorAll('.search-result[role="option"]');
    if (!items.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      updateActive(Math.min(activeIndex + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      updateActive(Math.max(activeIndex - 1, 0));
    } else if (e.key === 'Enter' && activeIndex >= 0) {
      e.preventDefault();
      items[activeIndex].click();
    } else if (e.key === 'Escape') {
      closeDropdown();
      input.blur();
    }
  });

  // ---- category shortcuts (shown when box is empty) ----
  // window.EM_CAT_IMAGES is injected by theme.liquid with asset URLs
  const CAT_IMG = window.EM_CAT_IMAGES || {};
  const CATEGORIES = [
    { label: 'Artboards',           handle: 'artboards' },
    { label: 'Boxes & Binders',     handle: 'boxes-binders' },
    { label: 'Slabs',               handle: 'slabs' },
    { label: 'Polaroids',           handle: 'polaroids' },
    { label: 'Sealed Cases',        handle: 'sealed-cases' },
    { label: 'Toys & Others',       handle: 'odd-balls' },
    { label: 'Magnets & Acrylics',  handle: 'magnets-acrylics' }
  ];

  function showCategories(query) {
    const matches = matchCategories(query);
    const label = (query && query.trim()) ? 'Categories' : 'Browse categories';
    let html = `<div class="search-section-label">${label}</div>`;
    if (matches.length) {
      html += matches.map(c => categoryRow(c, query)).join('');
    } else {
      html += `<p class="search-empty">No categories match "<strong>${escHtml(query)}</strong>".</p>`;
    }
    dropdown.innerHTML = html;
    openDropdown();
  }

  // ---- input handler ----
  const searchForm = searchWrap ? searchWrap.querySelector('form.mega-search') : null;
  const requiredMsg = document.getElementById('msRequiredMsg');

  input.addEventListener('input', () => {
    const q = input.value.trim();
    if (requiredMsg) requiredMsg.hidden = true;
    input.classList.remove('ms-input-error');
    clearTimeout(debounceTimer);
    if (q.length === 0) { showCategories(); return; }
    // Instantly show matching categories on every keystroke (dynamic update)
    showCategories(q);
    // Then debounce-fetch products and merge them in
    if (q.length >= 2) {
      debounceTimer = setTimeout(() => fetchSuggestions(q), 200);
    }
  });

  // Show categories on focus when empty, results when there's a query
  input.addEventListener('focus', () => {
    const q = input.value.trim();
    if (q.length === 0) { showCategories(); }
    else { showCategories(q); if (q.length >= 2) fetchSuggestions(q); }
  });

  // ---- prevent empty searches (#5) ----
  if (searchForm) {
    searchForm.addEventListener('submit', e => {
      if (input.value.trim().length === 0) {
        e.preventDefault();
        input.value = '';
        if (requiredMsg) requiredMsg.hidden = false;
        input.classList.add('ms-input-error');
        showCategories();
        input.focus();
      }
    });
  }

  // Close on outside click
  document.addEventListener('click', e => {
    if (!searchWrap.contains(e.target)) closeDropdown();
  });

  // Close on scroll (UX: keeps dropdown from floating weirdly)
  window.addEventListener('scroll', closeDropdown, { passive: true });

  // ---- custom category dropdown (image 4 style) ----
  const catToggle = document.getElementById('msCatToggle');
  const catMenu   = document.getElementById('msCatMenu');
  const catLabel  = document.getElementById('msCatLabel');
  const catValue  = document.getElementById('searchCatValue');

  if (catToggle && catMenu) {
    function openCat()  { catMenu.hidden = false; catToggle.setAttribute('aria-expanded', 'true'); }
    function closeCat() { catMenu.hidden = true;  catToggle.setAttribute('aria-expanded', 'false'); }

    catToggle.addEventListener('click', e => {
      e.stopPropagation();
      closeDropdown(); // close the search suggestions if open
      catMenu.hidden ? openCat() : closeCat();
    });

    catMenu.querySelectorAll('li[role="option"]').forEach(li => {
      li.addEventListener('click', () => {
        const val   = li.dataset.value || '';
        const label = li.querySelector('.ms-cat-label')?.textContent || 'All';
        catLabel.textContent = label;
        if (catValue) catValue.value = val;
        catMenu.querySelectorAll('li').forEach(x => x.classList.remove('selected'));
        li.classList.add('selected');
        closeCat();
        input.focus();
      });
    });

    document.addEventListener('click', e => {
      if (!catMenu.contains(e.target) && e.target !== catToggle && !catToggle.contains(e.target)) {
        closeCat();
      }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCat(); });
  }
})();

/* ============================================================
   PRODUCT LISTING — sort dropdown + filter form
   Works on collection and search pages.
   ============================================================ */
(function () {
  // Sort dropdown: update the sort_by param, preserve other params, reset page
  document.querySelectorAll('select[data-sort-select]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Facet forms (price + availability + other list filters):
  // auto-submit when a checkbox changes; price applies via Enter or the Apply button.
  document.querySelectorAll('form[data-facet-form]').forEach(form => {
    form.querySelectorAll('input[type="checkbox"]').forEach(box => {
      box.addEventListener('change', () => form.submit());
    });
  });
})();

/* ============================================================
   MOBILE DRAWER (hamburger menu) — with focus trap for a11y
   ============================================================ */
(function () {
  const burger  = document.getElementById('hdrBurger');
  const drawer  = document.getElementById('mobileDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const closeBtn = document.getElementById('drawerClose');
  if (!burger || !drawer || !overlay) return;

  let lastFocused = null;

  function focusables() {
    return drawer.querySelectorAll('a[href], button:not([disabled])');
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('open');
      drawer.classList.add('open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const first = focusables()[0];
    if (first) setTimeout(() => first.focus(), 50);
  }

  function closeDrawer() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.hidden = true; }, 260);
    if (lastFocused) lastFocused.focus();
  }

  burger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // Close drawer when a link is clicked
  drawer.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', closeDrawer);
  });

  // Keyboard: Escape closes, Tab is trapped inside the drawer
  document.addEventListener('keydown', e => {
    if (!drawer.classList.contains('open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      const items = Array.from(focusables());
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  // Auto-close if resized up to desktop
  window.addEventListener('resize', () => {
    if (window.innerWidth > 980 && drawer.classList.contains('open')) closeDrawer();
  });
})();
